import React, { useReducer, useEffect } from "react";
import * as microsoftTeams from "@microsoft/teams-js";
import TeamService from "services/TeamService";
import MicrosoftTeamsCard from "components/MicrosoftTeams/MicrosoftTeamsCard";
import "assets/scss/partials/microsoftTeams.scss";
import Scrollbar from "react-scrollbars-custom";
import CreateTeamDialogButton from "components/CreateTeam";
import JoinTeamDialogButton from "components/JoinTeam";
import MicrosoftTeamsHeader from "components/MicrosoftTeams/MicrosoftTeamsHeader";
import ReteamTab from "components/MicrosoftTeams/ReteamTab";
import { useGlobalContext } from "store/contexts/globalContext";
import { useHistory } from "react-router-dom";
import { ReactComponent as ArrowDown } from "assets/img/icons/arrowdown.svg";
import { ReactComponent as ArrowUp } from "assets/img/icons/arrowup.svg";
import MicrosoftTeamSearch from "components/MicrosoftTeams/MicrosoftTeamSearch";
import { msState, msReducer } from "store/reducers/msTeamReducer";
import Loader from "components/Loader";
import TeamSort from "components/TeamSort";

export default () => {
  const history = useHistory();
  const { microsoftConfigureTab } = useGlobalContext();
  const [
    {
      teams,
      loading,
      activeId,
      displayUpArrow,
      floading,
      searchedTeam,
      displayGeneralTab,
      searchedTName,
      sortOption,
    },
    dispatch,
  ] = useReducer(msReducer, msState);
  const loaderStyle = {
    display: "flex",
    justifyContent: "center",
  };

  useEffect(() => {
    if (microsoftConfigureTab) {
      microsoftTeams.app.notifySuccess();
    }
  }, [microsoftConfigureTab]);

  useEffect(() => {
    if (!microsoftConfigureTab) {
      return;
    }

    if (
      microsoftConfigureTab?.entityId &&
      microsoftConfigureTab?.frameContext === "content"
    ) {
      history.replace("/un-authorize");
      return;
    }

    //eslint-disable-next-line
  }, [microsoftConfigureTab]);

  const selectTeam = (team) => {
    dispatch({ type: "setActiveId", value: team.id });
    setContentUrl(team);
  };

  useEffect(() => {
    try {
      dispatch({ type: "setLoading", value: true });
      (async () => {
        await getTeams();
        dispatch({ type: "setLoading", value: false });
      })();
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message);
      }
    }
  }, []);

  useEffect(() => {
    if (teams.length === 0) return;

    if (floading) return;

    dispatch({ type: "setDisplayGeneralTab", value: true });

    //eslint-disable-next-line
  }, [teams]);

  const getTeams = async () => {
    try {
      const response = await TeamService.getAllTeams();

      dispatch({ type: "setTeams", value: response.data.data });

      microsoftTeams.app.notifySuccess();
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message);
      }
    }
  };

  const filterTeam = async ({ name = searchedTName, sort = sortOption }) => {
    dispatch({
      type: "setFilterLoading",
      value: true,
    });

    if (name) {
      dispatch({ type: "setSearchTName", value: name });
    }

    if (sort) {
      dispatch({ type: "setSortOption", value: sort });
    }

    dispatch({
      type: "setFilterTeam",
      value: { displayGeneralTab: false },
    });

    try {
      const response = await TeamService.getAllTeams(name, sort);
      dispatch({ type: "setTeams", value: response.data.data });

      if ("MY RETEAM".includes(name.toUpperCase()))
        dispatch({ type: "setDisplayGeneralTab", value: true });
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message);
      }
    }
    dispatch({
      type: "setFilterLoading",
      value: false,
    });
  };

  const setContentUrl = (team) => {
    /**
     * The content url for the tab is a required value that must be set.
     * The url value is the source url for your configured tab.
     * This allows for the addition of query string parameters based on
     * the settings selected by the user.
     */

    microsoftTeams.pages.config.setValidityState(true);
    microsoftTeams.pages.config.registerOnSaveHandler((saveEvent) => {
      microsoftTeams.pages.config.setConfig({
        contentUrl: `https://reteam.beremote.com/teams/${team.id}/timeline`,
        entityId: team.id,
        suggestedDisplayName: team.name,
      });

      saveEvent.notifySuccess();
    });

    /**
     * After verifying that the settings for your tab are correctly
     * filled in by the user you need to set the state of the dialog
     * to be valid.  This will enable the save button in the configuration
     * dialog.
     */
  };

  const createMSTeam = async (newTeam) => {
    dispatch({
      type: "setTeams",
      value: Array.from(new Set([newTeam, ...teams])),
    });
  };

  const handleScroll = (val) => {
    if (val.scrollTop > 100) {
      dispatch({
        type: "setDisplayArrow",
        value: true,
      });
    }
    if (val.scrollTop < 100) {
      dispatch({
        type: "setDisplayArrow",
        value: false,
      });
    }
  };

  const scroll = (value) => {
    let queryData = document.querySelector("#microsoftContent");
    if (queryData && value === "top") {
      queryData.scrollIntoView({ behavior: "smooth", block: "end" });
      return;
    }

    queryData.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="col-lg-12 middle-content">
      {!displayUpArrow && (
        <div className="msArrowDown">
          <ArrowDown onClick={() => scroll("top")} />
        </div>
      )}
      {displayUpArrow && (
        <div className="msArrowDown">
          <ArrowUp onClick={() => scroll("bottom")} />
        </div>
      )}
      <div className="wrapper">
        <MicrosoftTeamsHeader />
        <div className="teamSearchAndSort">
          {(teams.length !== 0 || searchedTeam) && (
            <MicrosoftTeamSearch
              setDisplayGeneralTab={(value) =>
                dispatch({
                  type: "setDisplayGeneralTab",
                  value: value,
                })
              }
              resetSearchName={() =>
                dispatch({ type: "setSearchTName", value: "" })
              }
              getTeams={getTeams}
              searchedTName={searchedTName}
              filterTeam={filterTeam}
              loading={loading}
              loaderStyle={loaderStyle}
              floading={floading}
              setFilterLoading={(value) =>
                dispatch({
                  type: "setFilterLoading",
                  value: value,
                })
              }
              searchTeam={searchedTeam}
              setSearchTeam={(value) =>
                dispatch({
                  type: "setTeamSearch",
                  value: value,
                })
              }
            />
          )}
          {teams.length !== 0 && <TeamSort filterTeam={filterTeam} />}
        </div>
        {(loading || floading) && (
          <div style={loaderStyle}>
            <Loader />
          </div>
        )}
        <div style={{ height: "calc(100vh - 65px)" }}>
          <Scrollbar onScroll={handleScroll}>
            <div style={{ padding: "15px 10px" }}>
              {teams?.length !== 0 && !floading && (
                <div className="teamsButton">
                  <CreateTeamDialogButton
                    createMSTeam={createMSTeam}
                    selectTeam={selectTeam}
                  />
                  <JoinTeamDialogButton
                    createMSTeam={createMSTeam}
                    selectTeam={selectTeam}
                  />
                </div>
              )}
              {teams?.length === 0 &&
                !loading &&
                !searchedTeam &&
                !floading && (
                  <div className="noTeamText">
                    <span>Currently you do not have any teams</span>
                    <div className="teamsButton">
                      <CreateTeamDialogButton
                        createMSTeam={createMSTeam}
                        selectTeam={selectTeam}
                      />
                      <JoinTeamDialogButton
                        createMSTeam={createMSTeam}
                        selectTeam={selectTeam}
                      />
                    </div>
                  </div>
                )}
              {teams?.length === 0 &&
                !floading &&
                !loading &&
                searchedTeam &&
                !displayGeneralTab && (
                  <span className="noTeamText">
                    You do not have any team related to that search.
                  </span>
                )}
              {!floading && (
                <div className="teams-cards">
                  <div className="microsoftTeamsContent" id="microsoftContent">
                    {displayGeneralTab && (
                      <ReteamTab
                        selectGeneralTab={selectTeam}
                        activeId={activeId}
                      />
                    )}
                    {teams.map((team) => (
                      <div
                        onKeyUp={() => setContentUrl(team)}
                        key={parseInt(team.id)}
                      >
                        <MicrosoftTeamsCard
                          key={parseInt(team.id)}
                          activeId={activeId}
                          team={team}
                          micrsoftTeam={true}
                          selectTeam={selectTeam}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </Scrollbar>
        </div>
      </div>
    </div>
  );
};
